import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { canCreateFollowupCall, getFollowupCall } from '../../../services/private/leads.service';
import CreateForm from './CreateForm';
import ShowFollowup from './ShowFollowup';

export default function CreateFolloups({
    showCreateFollowup,
    toggleCreateFollowup,
    followupsCount,
    reloadSideBarCount,
    intentOptions,
    leadInfoData,
    statusOptions,
    userProfile,
    leadAccess
}) {

    const params = useParams();
    const [followups, setFollowups] = useState([]);
    const [createFollowUpAllowed, setCreateFollowUpAllowed] = useState(false);

    const getAllFollowups = () => {
        canCreateFollowupCall(params.id).then(res => {
            if (res.status === 200) {
                setCreateFollowUpAllowed(res.data.data)
            }
        })

        getFollowupCall(params.id).then(res => {
            if (res.status === 200) {
                setFollowups(res.data.data)
            }
        })
    }

    const reloadFollowupsData = () => {
        getAllFollowups();
        reloadSideBarCount();
    }


    useEffect(() => {
        getAllFollowups()
    }, [])

    return (
        <>
            <div className={`slide-sidebar followups position-absolute ${showCreateFollowup ? "active" : "d-active"}`}>
                <div className="border-0 sidebar-title">
                    <div className="row align-itmes-center">
                        <div className="col-12">

                            <h2 className="mb-0 fz16 po black po pt-10 flex items-center">
                                <button className="border-0 bg-tr p-0 bck-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={toggleCreateFollowup}>
                                    <path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="white" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M10.4142 12L14.7071 16.2929C15.0976 16.6834 15.0976 17.3166 14.7071 17.7071C14.3166 18.0976 13.6834 18.0976 13.2929 17.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L13.2929 6.29289C13.6834 5.90237 14.3166 5.90237 14.7071 6.29289C15.0976 6.68342 15.0976 7.31658 14.7071 7.70711L10.4142 12Z" fill="#44444F" />
                                </svg></button>
                                <svg className="mr-8" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M15.7 4V3C15.7 2.44772 16.1477 2 16.7 2C17.2523 2 17.7 2.44772 17.7 3V4.00491C19.8162 4.10912 21.5 5.85793 21.5 8V17C21.5 19.2091 19.7091 21 17.5 21H7.5C5.29086 21 3.5 19.2091 3.5 17V8C3.5 5.79086 5.29086 4 7.5 4H7.7V3C7.7 2.44772 8.14772 2 8.7 2C9.25228 2 9.7 2.44772 9.7 3V4H11.7V3C11.7 2.44772 12.1477 2 12.7 2C13.2523 2 13.7 2.44772 13.7 3V4H15.7ZM15.7 6H13.7C13.7 6.55228 13.2523 7 12.7 7C12.1477 7 11.7 6.55228 11.7 6H9.7C9.7 6.55228 9.25229 7 8.7 7C8.14772 7 7.7 6.55228 7.7 6H7.5C6.39543 6 5.5 6.89543 5.5 8V17C5.5 18.1046 6.39543 19 7.5 19H17.5C18.6046 19 19.5 18.1046 19.5 17V8C19.5 6.96291 18.7106 6.11019 17.7 6.00987C17.6947 6.55761 17.249 7 16.7 7C16.1477 7 15.7 6.55228 15.7 6ZM9.5 12C8.94772 12 8.5 11.5523 8.5 11C8.5 10.4477 8.94772 10 9.5 10H16.5C17.0523 10 17.5 10.4477 17.5 11C17.5 11.5523 17.0523 12 16.5 12H9.5ZM9.5 16C8.94772 16 8.5 15.5523 8.5 15C8.5 14.4477 8.94772 14 9.5 14H14.5C15.0523 14 15.5 14.4477 15.5 15C15.5 15.5523 15.0523 16 14.5 16H9.5Z" fill="#3DD598"></path></svg>
                                Followups {followupsCount ? <span>{followupsCount}</span> : ''}</h2>
                        </div>

                    </div>
                </div>
                {/* <form> */}
                {
                    createFollowUpAllowed ?
                        <CreateForm
                            reloadFollowupsData={reloadFollowupsData}
                            intentOptions={intentOptions}
                            leadInfoData={leadInfoData}
                            statusOptions={statusOptions}
                            leadAccess={leadAccess}
                            userProfile={userProfile}
                        /> : " "
                }
                {/* Recent Followups */}

                {followups.length > 0 ? followups.map((data, index) => {
                    return (
                        <ShowFollowup
                            followup={data}
                            reloadFollowupsData={reloadFollowupsData}
                            key={String(index)}
                            intentOptions={intentOptions}
                            leadInfoData={leadInfoData}
                            leadAccess={leadAccess}
                            userProfile={userProfile}
                        />
                    )
                }) :
                    <div className="no-result-find d-flex flex-column align-items-center justify-content-center">
                        <figure><svg xmlns="http://www.w3.org/2000/svg" width="63" height="65" viewBox="0 0 63 65" fill="none">
                            <circle cx="33.1727" cy="35.6068" r="29.3934" fill="#F0F6FF" />
                            <path d="M39.6259 38.4741C39.1482 38.2353 30.7839 43.2533 30.545 44.2094C30.3062 45.1654 37.3318 58.8344 39.6259 63.8049C46.5082 62.2755 51.5744 58.229 53.2472 56.3969C53.2472 56.3969 40.2674 38.7946 39.6259 38.4741Z" fill="#0062FF" />
                            <circle opacity="0.1" cx="21.9407" cy="22.4632" r="20.0735" fill="#696974" />
                            <circle cx="20.5071" cy="20.0735" r="20.0735" fill="#B5B5BE" />
                            <circle cx="20.5078" cy="20.0732" r="16.25" fill="#D5D5DC" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M14.2217 35.0627C9.40488 32.2428 6.16973 27.0138 6.16973 21.0292C6.16973 12.0546 13.4451 4.77918 22.4197 4.77918C24.6483 4.77918 26.7722 5.22781 28.7058 6.03969C26.2992 4.63079 23.4978 3.82324 20.5078 3.82324C11.5332 3.82324 4.25781 11.0986 4.25781 20.0732C4.25781 26.8193 8.36853 32.6052 14.2217 35.0627Z" fill="#696974" />
                            <path d="M33.1716 35.3677L30.543 37.2794L33.1716 42.5368L36.7562 40.3861L33.1716 35.3677Z" fill="#B5B5BE" />
                        </svg></figure>
                        <h2 className='po black fz16 fw-po-medium mb-8'>No Followups</h2>
                        <p className='text-center black-dark-600 fz14 mb-0'>You have no Followups saved.<span className='d-md-block'> Please add to see here.</span></p>
                    </div>
                }


            </div>
        </>
    )
}